import React from "react";
import styled, { withTheme } from "styled-components";
import { Colors, Metrics } from "../../theme";
import { DataVisualizeKeys } from "../../theme/Colors";
import { ColorUtil } from "../../util";

export const Bubble = styled.div`
    position:relative;
    padding: 24px 32px;
    border: 1px solid ${props=>props.borderColor || Colors.lightBorderColor};
    border-radius: 8px;
    ${props=>props.height ? `height:${props.height}px;` : ""}
    ${props=>(props.hilight && props.size) ? `
        margin-bottom: ${(props.size/2)+10}px;
    ` : ""}
    ${props=>props.hilight ? `
        box-shadow: 0px ${Metrics.shadowDepth}px ${Metrics.shadowBlur}px 0 ${props.hilightColor};`
		: ""}
`;
export const ThemeBubble = withTheme((props)=>{
	const { colorType = DataVisualizeKeys.Primary, theme, children, hilight } = props;
	const color = ColorUtil.getVisualizeColor(theme, colorType, 0);
	return <Bubble {...props} hilight={hilight} hilightColor={color}>
		{props.children}
	</Bubble>;
});
const ThemeShadowBox = styled.div`
    border: 1px solid ${props=>props.color};
    box-shadow: ${props=>`
        0px ${Metrics.shadowDepth}px ${Metrics.shadowBlur}px 0 ${props.color};
    `}
`;
export const HilighBox = withTheme((props)=>{
	const { style, colorType = DataVisualizeKeys.Primary, theme, children } = props;
	const color = ColorUtil.getVisualizeColor(theme, colorType, 0);
	return <ThemeShadowBox style={{...style}} color={color}>{children}</ThemeShadowBox>;
});
const Arrow = styled.div`
    position: absolute;
    bottom:${props=>-props.size/2}px;
    left: 50%;
    width: ${props=>props.size}px;
    height: ${props=>props.size}px;
    background-color: ${Colors.backgroundColor};
    border-right: 1px solid ${props=>props.borderColor || Colors.lightBorderColor};
    border-bottom: 1px solid ${props=>props.borderColor || Colors.lightBorderColor};
    transform: translateX(-50%) rotate(45deg);
    ${props=>props.hilight ? `
        box-shadow: ${Metrics.shadowDepth}px ${Metrics.shadowDepth}px ${Metrics.shadowDepth/2}px 0 ${props.hilightColor};
    ` : ""}
`;
export default (props)=>{
	const { style, children, hilight, hilightColor, size = 36 } = props;
	return <Bubble {...style} 
		hilight={hilight} hilightColor={hilightColor} 
		size={size}>
		{hilight ? <Arrow hilight={hilight} hilightColor={hilightColor} size={size} /> 
			: undefined}
		{children}
	</Bubble>;
};


// WEBPACK FOOTER //
// ./src/components/layout/SpeechBubble.js